import React from 'react';
import QrReader from 'react-qr-reader';

class Qrcode extends React.Component { 
    constructor(props) {
        super(props);
        this.state = {
            delay:100,
            result: 'No result'
        };
        this.handleScan = this.handleScan.bind(this);
    }
    handleScan(data) {
        if (data) {
            this.setState({result: data},()=>{
                this.props.qrcode(data);
            });
        }
    }
    handleError(err) {
        console.error(err);
    }
    render() {
        return (
            <QrReader
                delay={this.state.delay}
                onError={this.handleError}
                onScan={this.handleScan}
                className="qrcode" 
            />
        );
    }
}
 

export default Qrcode;


// WEBPACK FOOTER //
// ./src/core/qrcode.js